export interface IStorageContentModel {
  storageContentId: number;
  storageContentUrl: string;
  container: string;
  fileName: string;
}
export class StorageContentModel implements IStorageContentModel {
  storageContentId: number;
  storageContentUrl: string;
  container: string;
  fileName: string;

  constructor(
    params: Partial<IStorageContentModel> = {} as IStorageContentModel,
  ) {
    const {
      storageContentId = 0,
      storageContentUrl = '',
      container = '',
      fileName = '',
    } = params;

    this.storageContentId = storageContentId;
    this.storageContentUrl = storageContentUrl;
    this.container = container;
    this.fileName = fileName;
  }
}
